import { TicketKeys } from './data'

export const getTicketPage = (key: string) => `${TicketKeys.ticketPage}.${key}`
